import _asyncToGenerator from "/home/circleci/project/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/circleci/project/node_modules/@babel/runtime/regenerator/index.js";
import { shouldEnableIntegrationHelper, segmentShouldBeDisabled } from './blocking-helpers';
import { logger } from './logger';
import { parseAllCategories } from './config-helpers';
// Block all device mode destinations
export var addBlockingMiddleware = function addBlockingMiddleware(cdnSettingsP, analyticsInstance, filterSettings) {
  var blockDeviceMode = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var creationName, payload, next, cdnSettings, eventCategoryPreferences, disabled;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            creationName = _ref.integration, payload = _ref.payload, next = _ref.next;
            _context.next = 3;
            return cdnSettingsP;
          case 3:
            cdnSettings = _context.sent;
            eventCategoryPreferences = payload.obj.context.consent.categoryPreferences;
            disabled = !shouldEnableIntegrationHelper(creationName, cdnSettings, eventCategoryPreferences, filterSettings);
            logger.debug("Destination middleware called: ".concat(creationName), {
              DROPPED: disabled,
              categoryPreferences: eventCategoryPreferences,
              payload: payload.obj,
              filterSettings: filterSettings
            });
            if (!disabled) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", null);
          case 9:
            next(payload);
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function blockDeviceMode(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  analyticsInstance.addDestinationMiddleware('*', blockDeviceMode);
  // Block segment itself (Segment.io isn't currently allowed in addDestinationMiddleware)
  var blockSegmentAndEverythingElse = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
      var payload, next, cdnSettings, eventCategoryPreferences, consentSettings, disabled;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            payload = _ref3.payload, next = _ref3.next;
            _context2.next = 3;
            return cdnSettingsP;
          case 3:
            cdnSettings = _context2.sent;
            eventCategoryPreferences = payload.obj.context.consent.categoryPreferences;
            consentSettings = filterSettings.integrationCategoryMappings ? {
              hasUnmappedDestinations: false,
              allCategories: parseAllCategories(filterSettings.integrationCategoryMappings)
            } : cdnSettings.consentSettings;
            disabled = segmentShouldBeDisabled(eventCategoryPreferences, consentSettings);
            logger.debug('Source middleware called', {
              DROPPED: disabled,
              categoryPreferences: eventCategoryPreferences,
              payload: payload.obj,
              filterSettings: filterSettings,
              consentSettings: consentSettings
            });
            if (!disabled) {
              _context2.next = 10;
              break;
            }
            return _context2.abrupt("return", null);
          case 10:
            next(payload);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function blockSegmentAndEverythingElse(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  analyticsInstance.addSourceMiddleware(blockSegmentAndEverythingElse);
};